<template>
    <div class="min-h-screen bg-[var(--background-primary)] pt-40 text-[var(--text-primary)] overflow-x-hidden">
        <NsHeader />
        <slot />
        <NsFooter />
    </div>
</template>

<script setup lang="ts">
const NsHeader = defineAsyncComponent(() => import("@/components/NsHeader.vue"));
const NsFooter = defineAsyncComponent(() => import("@/components/NsFooter.vue"));

</script>